import { render } from "./case-notice.vue?vue&type=template&id=2ef86654&scoped=true"
import script from "./case-notice.vue?vue&type=script&lang=js"
export * from "./case-notice.vue?vue&type=script&lang=js"

import "./case-notice.vue?vue&type=style&index=0&id=2ef86654&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef86654"]])

export default __exports__